export default __webpack_public_path__ + "static/media/DonorsIcon.22d925f5.svg";